import React from "react";
import { Sparkles, Star, Users, Wand2 } from "lucide-react";
import { motion } from "framer-motion";

const benefits = [
  {
    icon: <Wand2 className="w-6 h-6 text-purple-600" />,
    title: "Effortless Feedback Collection",
    desc: "Capture client experiences through smart, non-intrusive surveys right after each appointment.",
  },
  {
    icon: <Users className="w-6 h-6 text-purple-600" />,
    title: "Build Loyal Relationships",
    desc: "Reward repeat visits and personalize communication to keep your clients coming back.",
  },
  {
    icon: <Sparkles className="w-6 h-6 text-purple-600" />,
    title: "Automated Reviews",
    desc: "Let Zola automatically generate positive reviews on Google and socials after great experiences.",
  },
  {
    icon: <Star className="w-6 h-6 text-purple-600" />,
    title: "Track Team Performance",
    desc: "Gain insights into how each beautician performs and where service can improve.",
  },
];

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const WhyZolaBeauty = () => {
  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
        >
          Why Beauty Professionals <span className="text-purple-600">Choose Zola</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto"
        >
          Everything you need to manage client relationships, gather feedback,
          and grow your salon — all in one platform.
        </motion.p>

        {/* Benefit Cards */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {benefits.map((item, idx) => (
            <motion.div
              key={idx}
              variants={cardVariants}
              className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition"
            >
              <div className="flex justify-center mb-4">{item.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhyZolaBeauty;
